import { EventEmitter } from 'eventemitter3';

export const eventBus = new EventEmitter();

export const EMIT_EVENT = {
  TOKEN_EXPIRED: 'token_expired',
  LOCAL_STORAGE_AUTH_DATA_READY: 'local_storage_auth_data_ready',
};
